import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, Button, CircularProgress } from '@mui/material'
import { useTranslation } from 'react-i18next'
import GetAppIcon from '@mui/icons-material/GetApp'

import { downloadCallsAsCsv } from '../../utils/csvExport'
import styles from './DashboardHeader.module.scss'

/**
 * DashboardHeader component displays the campaign indicator and CSV download button
 */
export const AnalyticsDashboardHeaderView = ({
  campaignName,
  isLoading = false,
  startDate,
  endDate
}) => {
  const { t } = useTranslation()
  const [isCsvLoading, setIsCsvLoading] = useState(false)

  const handleDownloadCsv = () => {
    downloadCallsAsCsv({
      campaignName,
      startDate,
      endDate,
      setLoading: setIsCsvLoading
    })
  }

  return (
    <Box className={styles.headerSection}>
      {/* Campaign and Download row */}
      <Box className={styles.campaignDownloadRow}>
        {/* Campaign indicator */}
        <Typography
          variant='body1'
          className={styles.campaignIndicator}
        >
          <span className={styles.campaignLabel}>{t('calls.campaign')}:</span>
          {campaignName ||
            (isLoading ? t('analytics.loadingCampaign') : t('analytics.noCampaignSelected'))}
        </Typography>

        {/* CSV download button */}
        <Button
          variant='contained'
          color='primary'
          size='small'
          startIcon={isCsvLoading ? null : <GetAppIcon />}
          onClick={handleDownloadCsv}
          className={styles.downloadButton}
          disabled={isLoading || isCsvLoading}
          title='Download CSV data for selected date range'
        >
          {isCsvLoading
            ? (
              <span className={styles.downloadButtonContent}>
                <CircularProgress size={16} thickness={4} className={styles.downloadProgress} />
                {t('common.preparing', 'Preparing...')}
              </span>
              )
            : (
                t('common.downloadCsv', 'Download CSV for Date Range')
              )}
        </Button>
      </Box>
    </Box>
  )
}

AnalyticsDashboardHeaderView.propTypes = {
  campaignName: PropTypes.string,
  isLoading: PropTypes.bool,
  startDate: PropTypes.object,
  endDate: PropTypes.object
}

export const DashboardHeader = AnalyticsDashboardHeaderView

export default DashboardHeader
